import { Box, Card, CardContent, Typography } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Brush,
  Legend,
} from "recharts";
import { ChartTooltip, COLORS } from "../../../../ui/Theme";
import { ListDivider } from "../../../../ui/ListStyles";
import useResponsive from "../../../../components/hooks/useResponsive";
import NotFound from "../../../../components/notfound/NotFound";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const { azad, nima } = payload[0].payload;
    return (
      <ChartTooltip>
        <Typography sx={{ fontSize: "12px", fontWeight: 900 }}>
          {label}
        </Typography>
        <ListDivider flexItem />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: 0.5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              color: COLORS.BLUE,
            }}
          >
            <Typography sx={{ fontSize: "12px" }}>آزاد :</Typography>
            <Typography sx={{ fontSize: "12px", fontWeight: 900 }}>
              {azad}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              color: COLORS.ORANGE,
            }}
          >
            <Typography sx={{ fontSize: "12px" }}>توافقی :</Typography>
            <Typography sx={{ fontSize: "12px", fontWeight: 900 }}>
              {nima}
            </Typography>
          </Box>
        </Box>
      </ChartTooltip>
    );
  }
  return null;
};

const DollarCommodityPriceChart = ({ chartData }) => {
  const { isMd } = useResponsive();

  const formattedData = chartData.map((item) => ({
    x: item.trade_date,
    azad: item.azad,
    nima: item.nima,
  }));

  const totalDataLength = formattedData?.length || 0;
  const startIndex = Math.max(0, totalDataLength - (isMd ? 100 : 50));
  const endIndex = totalDataLength - 1;

  return (
    <Card
      sx={{
        border: "1px solid",
        borderColor: COLORS.SOFTGRAY,
        padding: 0,
        minHeight: 500,
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{ fontSize: { xs: "16px", md: "20px" }, fontWeight: 700 }}
        >
          قیمت دلاری کالا
        </Typography>
        {chartData.length < 1 ? (
          <Box sx={{ height: 500 }}>
            <NotFound />
          </Box>
        ) : (
          <ResponsiveContainer width="100%" height={500}>
            <LineChart
              syncId="priceChart"
              data={formattedData}
              margin={{ top: 0, right: 0, bottom: 20, left: 0 }}
            >
              <CartesianGrid strokeDasharray="0 0" stroke={COLORS.SOFTGRAY} />
              <XAxis
                stroke={COLORS.GRAY}
                dataKey="x"
                tickMargin={10}
                angle={-25}
                tickFormatter={(date) => {
                  const [year, month] = date.split("-");
                  return `${year}-${month}`;
                }}
              />
              <YAxis
                textAnchor="start"
                tickMargin={10}
                stroke={COLORS.GRAY}
                domain={["auto", "auto"]}
              />
              <Legend
                wrapperStyle={{
                  width: "fit-content",
                  top: -10,
                  right: 0,
                  lineHeight: "20px",
                }}
                verticalAlign="top"
                formatter={(value) => {
                  if (value === "azad") {
                    return <span style={{ marginRight: "5px" }}>آزاد</span>;
                  } else if (value === "nima")
                    return <span style={{ marginRight: "5px" }}>توافقی</span>;
                  return value;
                }}
              />
              <Tooltip cursor={{ fill: COLORS.SOFTGRAY }} content={<CustomTooltip />} />
              <Line
                type="monotone"
                dataKey="azad"
                stroke={COLORS.BLUE}
                strokeWidth={2}
                dot={false}
              />
              <Line
                type="monotone"
                dataKey="nima"
                stroke={COLORS.ORANGE}
                strokeWidth={2}
                dot={false}
              />
              <Brush
                dataKey="x"
                height={30}
                startIndex={startIndex}
                endIndex={endIndex}
                stroke={COLORS.BLUE}
                travellerWidth={10}
                y={460}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default DollarCommodityPriceChart;
